import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

import { AuthenticationService } from '@cjm/shared/authentication/auth';
import { ButtonClasses, ButtonComponent, FaIconComponent } from '@cjm/shared/ui/common';

import { ModalDataModule, ModalDialogService } from '../../../data';

@Component({
	selector: 'cjm-login-modal',
	templateUrl: './login-modal.component.html',
	styleUrl: 'login-modal.component.scss',
	host: {
		class: 'c-login-modal'
	},
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [ModalDataModule, ButtonComponent, TranslateModule, FaIconComponent]
})
export class LoginModalComponent {
	@Input() public title: string;
	@Input() public text: string;
	@Input() public confirmButton: { text: string; title: string } = null;
	@Input() public cancelButton: { text: string; title: string } = null;
	@Input() public loginCallback: string;

	public readonly buttonClasses: typeof ButtonClasses = ButtonClasses;

	constructor(
		private readonly authService: AuthenticationService,
		private readonly modalService: ModalDialogService
	) {}

	/**
	 * login
	 *
	 * The login method is used to redirect the user to the login flow.
	 */
	public login(): void {
		// Redirect to login page with the provided callback
		this.authService
			.switch({
				customCallBack: this.loginCallback
			})
			.subscribe();
	}

	/**
	 * close
	 *
	 * The close method is used to close the modal through the service.
	 */
	public close(): void {
		this.modalService.instantCloseModal();
	}
}
